<section class="legend">
  <div class="legend-title">{{ 'TGA.Advice.General.RiskAnalysis.Legend.Title' | translate }}</div>

  <div class="legend-items">
    @if (isVarietyProperties()) {
      <div class="legend-item">
        <span class="legend-dot dot-likely" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.IncreasedRisk' | translate }}</span>
      </div>
    } @else {
      <div class="legend-item">
        <span class="legend-dot dot-no" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.No' | translate }}</span>
      </div>

      <div class="legend-item">
        <span class="legend-dot dot-present" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.Present' | translate }}</span>
      </div>

      <div class="legend-item">
        <span class="legend-dot dot-likely" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.Likely' | translate }}</span>
      </div>

      <div class="legend-item">
        <span class="legend-dot dot-very-likely" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.VeryLikely' | translate }}</span>
      </div>

      <div class="legend-item">
        <span class="legend-dot dot-high" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.High' | translate }}</span>
      </div>
      <div class="legend-item">
        <span class="legend-dot dot-unknown" aria-hidden="true"></span>
        <span class="legend-label">{{ 'TGA.Advice.General.RiskAnalysis.Legend.Unknown' | translate }}</span>
      </div>
    }
  </div>
</section>
